export const normalizePlate = value => String(value || "").toLocaleUpperCase("tr-TR").replace(/\s+/g, "");

export function nextVehicleSerial(records, region, plate) {
  const normalized = normalizePlate(plate);
  const prefix = String(region?.seriPrefix || "").trim().toLocaleUpperCase("tr-TR");
  const digits = Number(region?.seriHane) || 4;
  if (!region?.id || !normalized || !prefix) return "";
  const numbers = records.filter(record => record.durum !== "IPTAL" && record.bolgeId === region.id && normalizePlate(record.plaka) === normalized)
    .map(record => String(record.seriNo || "").trim().toLocaleUpperCase("tr-TR"))
    .filter(serial => serial.startsWith(prefix) && serial.length === prefix.length + digits && /^\d+$/.test(serial.slice(prefix.length)))
    .map(serial => Number(serial.slice(prefix.length)));
  if (!numbers.length) return "";
  const next = String(Math.max(...numbers) + 1);
  return next.length <= digits ? `${prefix}${next.padStart(digits, "0")}` : "";
}
